import { Blockquote as TiptapBlockquote } from '@tiptap/extension-blockquote'
import { BlockquoteActionButton } from '@/tiptap/extensions/components/ActionButton'

export default TiptapBlockquote.extend({
  addOptions() {
    return {
      ...(this.parent ? this.parent() : {}),
      HTMLAttributes: { class: 'blockquote' },
      button: ({ editor, t }) => ({
        component: BlockquoteActionButton,
        componentProps: { editor, t },
      }),
    }
  },
})
